import React from 'react';
import { Link, Image } from './common/NextAdapters';
import { Icon } from '@iconify/react';
import { useAuthStore } from '../store';

const BASE_COLUMNS = [
  {
    heading: 'Watch',
    links: [
      { label: 'Movies', href: '/browse?type=movies' },
      { label: 'Series', href: '/browse?type=series' },
      { label: 'Genres', href: '/categories' },
      { label: 'Watchlist', href: '/watchlist' },
    ],
  },
  {
    heading: 'Account',
    links: [
      { label: 'Sign in', href: '/login' },
      { label: 'Create an account', href: '/login?tab=register' },
      { label: 'Plans and pricing', href: '/subscribe' },
    ],
  },
  {
    heading: 'Creators',
    links: [
      { label: 'Creator Studio', href: '/creator/dashboard' },
      { label: 'Upload Video', href: '/creator/upload-movie' },
      { label: 'Creator Payouts', href: '/creator/payouts' },
    ],
  },
];

const SOCIAL = [
  { icon: 'ph:instagram-logo', label: 'Kast on Instagram', href: 'https://instagram.com' },
  { icon: 'ph:x-logo', label: 'Kast on X', href: 'https://x.com' },
  { icon: 'ph:youtube-logo', label: 'Kast on YouTube', href: 'https://youtube.com' },
];

export function SiteFooter() {
  const token = useAuthStore((s) => s.token);
  const isAuthenticated = !!token;

  const columns = React.useMemo(() => {
    return BASE_COLUMNS.map((col) => {
      if (col.heading === 'Watch' && !isAuthenticated) {
        return {
          ...col,
          links: col.links.filter((l) => l.href !== '/watchlist'),
        };
      }
      return col;
    });
  }, [isAuthenticated]);

  return (
    <footer className="mt-20 border-t border-white/10 bg-[#07050e]">
      <div className="mx-auto max-w-[1600px] gutter py-14">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Image
              src="/logo-full.png"
              alt="Kast"
              width={132}
              height={40}
              className="h-8 w-auto"
            />
            <p className="mt-4 max-w-[34ch] text-sm leading-relaxed text-muted-foreground">
              Streaming films and series, with a home for African cinema and stories made close to home.
            </p>
            <div className="mt-5 flex gap-2">
              {SOCIAL.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  aria-label={item.label}
                  target="_blank"
                  rel="noreferrer"
                  className="flex size-9 items-center justify-center rounded-full border border-white/10 text-muted-foreground transition-colors hover:border-white/30 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
                >
                  <Icon icon={item.icon} className="size-4" />
                </a>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <nav key={column.heading} aria-label={column.heading}>
              <h2 className="text-sm font-semibold text-foreground tracking-wide uppercase">{column.heading}</h2>
              <ul className="mt-3 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-muted-foreground gap-4">
          <p>© {new Date().getFullYear()} Kast. All rights reserved.</p>
          <div className="flex gap-6">
            <Link href="/terms" className="hover:text-foreground transition-colors">Terms of Use</Link>
            <Link href="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link href="/help" className="hover:text-foreground transition-colors">Help Centre</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
